<template>
	<div class="dynvibeBox dynvibeSearch" id="dynvibeSearchFiltersBase" style="min-height: 150px; padding-right: 0; padding-left: 0">
		<div class="col-lg-12 dynvibeTitleBox" data-v-6c01fb0d="">
			<h2>Create rules</h2>
		</div>
		<div class="col-lg-12 dynvibeModalAdvancedSearchField">
			<div class="col-lg-4" style="border-right: 1px solid #eee">
				<h5>Mastertag</h5>
				<input
					class="form-control dynvibeSearchInputSearch dynvibeListMastertagsFromPost listMastertag"
					type="text"
					name="tagrule"
					list="allMastertag"
					@change="similarMastertags()"
					v-model="selectedMt"
				/>
				<datalist id="allMastertag">
					<option v-for="mastertag in mastertags" :key="mastertag">{{ mastertag }}</option>
				</datalist>
			</div>
			<div class="col-lg-4" id="group1CreateRule" data-search-type="group1Words">
				<h5>Group 1</h5>
				<input class="dynvibeSearchInputSearch group1Word" type="text" v-model="group1" />
				<span class="add-synonyms" @click="showSynonyms(1)">Add synonyms?</span>
				<div style="display: none" id="synomyms_group1" v-show="showSyn1">
					<table class="table table-striped table-bordered" id="tableSyn1">
						<thead>
							<tr>
								<th>Synonyms for group 1</th>
								<th><span class="glyphicon glyphicon-plus" @click="addSynonymRow(1)" style="cursor: pointer"></span></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in rowSynonym1" :key="index">
								<td contenteditable="true" @blur="blur($event, item, index, 1)">{{ item }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="col-lg-4" id="group2CreateRule" data-search-type="group2Words">
				<h5>Group 2</h5>
				<input class="dynvibeSearchInputSearch group2Word" type="text" v-model="group2" />
				<span class="add-synonyms" @click="showSynonyms(2)">Add synonyms?</span>
				<div style="display: none" id="synomyms_group2" v-show="showSyn2">
					<table class="table table-striped table-bordered" id="tableSyn2">
						<thead>
							<tr>
								<th>Synonyms for group 2</th>
								<th><span class="glyphicon glyphicon-plus" @click="addSynonymRow(2)" style="cursor: pointer"></span></th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in rowSynonym2" :key="index">
								<td contenteditable="true">{{ item }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
		<div class="col-lg-12 dynvibeModalAdvancedSearchField" v-if="!existingMastertag">
			<div class="col-lg-4" style="border-right: 1px solid #eee">
				<span v-if="sizeSimilar > 0" @click="showSimilar = true" class="similar">{{ sizeSimilar }} similar mastertags</span>
				<div v-if="showSimilar">
					<div v-for="mt in similar" :key="mt">
						<div class="dynvibeModalAdvancedSearchWords">
							<div class="dynvibeModalAdvancedSearchWord">
								<span>"{{ mt }}"</span>
							</div>
						</div>
					</div>
				</div>
				<div class="col-lg-12" v-if="textToButton.length > 0">
					<span v-for="(value, index) in textToButton" :key="index">
						<button
							class="grey"
							style="background-color: #fcfcfc"
							:value="value"
							@click="tagText1(value)"
							@contextmenu="tagText2(value, $event)"
						>
							{{ value }}
						</button>
					</span>
				</div>
			</div>
			<div class="col-lg-4">
				<span style="text-transform: uppercase">Select subcategory to affect</span><br />
				<select class="dynvibeModalAdvancedSearchInput dynvibeListMastertags" @change="selectCategories()" v-model="filterCategory">
					<option value="">Categories</option>
					<option v-for="category in categories" v-bind:key="category" :value="category">{{ category }}</option>
				</select>
				<select class="dynvibeModalAdvancedSearchInput dynvibeListMastertags" v-model="filterSubcategory">
					<option value="">Subcategories</option>
					<option v-for="subcategory in subcategories" v-bind:key="subcategory" :value="subcategory">{{ subcategory }}</option>
				</select>
				<span class="dynvibeModalAdvancedSearchInputAdd icon-plus" @click="addFilterSubCategory()"></span>
				<span style="text-transform: uppercase">Tagclass for your mastertag</span><br />
				<select class="dynvibeModalAdvancedSearchInput dynvibeListMastertags" v-model="filterTagclass">
					<option>Brand</option>
					<option>Tag</option>
				</select>
				<span style="text-transform: uppercase">Language for your mastertag</span><br />
				<select class="dynvibeModalAdvancedSearchInput dynvibeListMastertags" v-model="selectedLanguage">
					<option value>Choose language</option>
					<option v-for="lang in languageslist" :value="lang.id" :key="lang.id">
						{{ lang.value }}
					</option>
				</select>
			</div>
			<div class="col-lg-4">
				<div v-if="filterSubcategories.length === 0" class="dynvibeModalAdvancedSearchWords"></div>
				<div v-else>
					<div v-for="subcategory in filterSubcategories" v-bind:key="subcategory">
						<div class="dynvibeModalAdvancedSearchWords">
							<div class="dynvibeModalAdvancedSearchWord" @click="removeFilterSubCategory(subcategory)">
								<span>"{{ subcategory }}"</span><i class="icon-x"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "createrules",
	props: {
		textToButton: {
			type: Array,
			default: function () {
				return [];
			},
		},
	},
	data() {
		return {
			selectedMt: "",
			existingMastertag: false,
			categories: [],
			subcategories: [],
			mastertags: [],
			filterCategories: [],
			filterCategory: "",
			filterSubcategories: [],
			languageslist: [],
			filterSubcategory: "",
			filterTagclass: "",
			group1: "",
			group2: "",
			showSyn1: false,
			showSyn2: false,
			rowSynonym1: [],
			rowSynonym2: [],
			syn1Showed: false,
			syn2Showed: false,
			sizeSimilar: 0,
			similar: [],
			showSimilar: false,
			selectedLanguage: "none",
		};
	},
	components: {},
	methods: {
		loadComponent() {
			this.getData("trendFilter");
		},
		treatResponse(response) {
			this.categories = response.data.categories;
			this.subcategories = response.data.allsubcats;
			this.mastertags = response.data.mastertags;
		},
		addFilterCategory() {
			if (!this.filterCategories) {
				this.filterCategories = [this.filterCategory];
			} else if (!this.filterCategories.includes(this.filterCategory)) {
				this.filterCategories.push(this.filterCategory);
			}
		},
		removeFilterCategory(category) {
			this.filterCategories = this.filterCategories.filter((filterCategory) => filterCategory !== category);
		},
		addFilterSubCategory() {
			if (this.filterSubcategory != "") {
				if (!this.filterSubcategories) {
					this.filterSubcategories = [this.filterSubcategory];
				} else if (!this.filterSubcategories.includes(this.filterSubcategory)) {
					this.filterSubcategories.push(this.filterSubcategory);
				}
				this.filterSubcategory = "";
			}
		},
		removeFilterSubCategory(subcategory) {
			this.filterSubcategories = this.filterSubcategories.filter((filterSubcategory) => filterSubcategory !== subcategory);
		},
		showSynonyms(group) {
			if (group == 1) {
				if (this.showSyn1 == false) {
					this.showSyn1 = true;
				} else {
					this.showSyn1 = false;
				}
				if (this.syn1Showed == false) {
					this.addSynonymRow(group);
					this.syn1Showed = true;
				}
			} else {
				if (this.showSyn2 == false) {
					this.showSyn2 = true;
				} else {
					this.showSyn2 = false;
				}
				if (this.syn2Showed == false) {
					this.addSynonymRow(group);
					this.syn2Showed = true;
				}
			}
		},
		addSynonymRow(group) {
			let addRow1 = "";
			if (group == 1) {
				this.rowSynonym1.push(addRow1);
			} else {
				this.rowSynonym2.push(addRow1);
			}
		},
		blur(event, item, index, group) {
			let text = event.target.innerText;
			event.target.innerText = text;
			if (group == 1) {
				this.rowSynonym1[index] = text;
			} else {
				this.rowSynonym2[index] = text;
			}
		},
		selectCategories() {
			let params = {};
			this.subcategories = [];
			if (this.filterCategory) {
				params = {
					label: this.filterCategory,
					type: "cat",
				};
			}
			this.$axios
				.get(this.$backendUrl + "getCategories", {
					params: params,
					paramsSerializer: function (params) {
						return this.$Qs.stringify(params, { arrayFormat: "brackets" });
					},
				})
				.then((response) => {
					this.subcategories = response.data.subcategories;
				});
		},
		similarMastertags() {
			let params = { mastertags: this.selectedMt };
			this.$axios
				.get(this.$backendUrl + "checkSimilar", {
					params: params,
					paramsSerializer: function (params) {
						return this.$Qs.stringify(params, { arrayFormat: "brackets" });
					},
				})
				.then((response) => {
					this.similar = response.data.similar;
					this.showSimilar = false;
					if (this.similar.indexOf(this.selectedMt) != -1) {
						this.existingMastertag = true;
					} else {
						this.existingMastertag = false;
					}

					this.sizeSimilar = response.data.similar.length;
					if (this.sizeSimilar === 1 && this.similar[0] === this.selectedMt) {
						this.sizeSimilar = 0;
						this.similar = [];
					}
				});
		},
		tagText1(value) {
			this.group1 += value + " ";
		},
		tagText2(value, event) {
			event.preventDefault();
			this.group2 += value + " ";
		},
		resetFields() {
			this.group1 = "";
			this.group2 = "";
			this.selectedMt = "";
			this.rowSynonym1 = [];
			this.rowSynonym2 = [];
			this.sizeSimilar = 0;
			this.selectedLanguage = "none";
			this.filterCategory = "";
			this.filterSubcategory = "";
			this.filterTagclass = "";
		},
		updateMastertags(mastertags) {
			this.mastertags = mastertags;
		},
	},
};
</script>

<style scoped>
.similar {
	color: red;
	text-decoration: underline;
	cursor: pointer;
}

input.dynvibeModalAdvancedSearchInput {
	max-width: none;
}

.add-synonyms {
	cursor: pointer;
	font-size: 11px;
	font-weight: bold;
	margin-bottom: 20px;
}

.add-synonyms:hover {
	text-decoration: underline;
}

.dynvibeModalAdvancedSearchField {
	padding: 0;
	border-top: none;
}
</style>
